import { useQuery } from 'react-query';
import { useCurrentUserCtx } from '../../contexts/CurrentUser';
import { AnchorAPI } from '../../modules/AnchorAPI';

const FETCH_SPOTIFY_ACCOUNT_ANALYTICS = 'fetchSpotifyAccount';

export function useFetchSpotifyAccount({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) {
  const {
    state: { userId },
  } = useCurrentUserCtx();

  const { data, status, refetch } = useQuery(
    [FETCH_SPOTIFY_ACCOUNT_ANALYTICS, userId],
    () =>
      AnchorAPI.fetchSpotifyAccount({
        userId: userId!,
      }),
    {
      enabled: !!userId && enabled,
    }
  );

  return {
    data,
    status,
    errorStatus: data?.status,
    refetch,
    FETCH_SPOTIFY_ACCOUNT_ANALYTICS,
  };
}
